import { Box, VBox } from "@ui/box/Box"
import { Error } from "@ui/error/Error"
import { Typo } from "@ui/text/Typo"
import { DS } from "../ds/Kit"
import { S_UNIVERSAL_DIALOG } from "./universalDialog/signals"

const CardIssuanceErrorContent = ({ error }: { error: IError }) => (
	<VBox gap='16px' role='alert' sx={{ alignItems: "center", textAlign: "center" }}>
		<Box aria-hidden sx={{ width: "56px", height: "56px", borderRadius: "50%", display: "grid", placeItems: "center", background: "#FEF2F2", color: "#B91C1C" }}>
			<svg width='26' height='26' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
				<circle cx='12' cy='12' r='9' /><path d='M12 7.5v5.5M12 16.5h.01' />
			</svg>
		</Box>
		<Typo sx={{ fontSize: "18px", fontWeight: 700, color: DS.ink, letterSpacing: "-0.02em" }}>This card could not be issued</Typo>
		<Box sx={{ width: "100%", padding: "14px 16px", borderRadius: DS.radius, border: "1px solid #FECACA", background: "#FEF2F2", textAlign: "left" }}>
			<Error error={error} />
		</Box>
		<Typo sx={{ fontSize: "14px", lineHeight: 1.5, color: DS.muted }}>
			Review the reason above and try again. If it keeps happening, contact support.
		</Typo>
	</VBox>
)

export const openCardIssuanceError = (error: IError) => {
	S_UNIVERSAL_DIALOG.invoke({
		label: "Card issuance failed",
		content: <CardIssuanceErrorContent error={error} />,
		closeDialog: () => S_UNIVERSAL_DIALOG.invoke(null)
	})
}
